import { lm } from '../../listenerMiddleware';
import * as videoMergeActions from './actions';
import { api } from '../../../general/apiScenarios';
import { runTask } from '@myua/api';
import { z } from 'zod';

export const videoMergeListeners = () => {
  watchMergeSubmitted();
  watchTaskCreated();
};

function watchMergeSubmitted() {
  lm.takeLeading(videoMergeActions.mergeSubmitted, async ({ payload }, { dispatch }) => {
    dispatch(videoMergeActions.taskCreationStarted());

    const result = await api.crhub.videoMerge.merge(payload);

    if (!result.success) {
      dispatch(
        videoMergeActions.taskCreationFailed({
          errorMessage: formatSubmitErrorMessage(result.data.response),
        }),
      );
      return;
    }

    const parsed = z.object({ task_id: z.string() }).safeParse(result.data.response);

    if (!parsed.success) {
      dispatch(
        videoMergeActions.taskCreationFailed({
          errorMessage: 'Failed to start video merge: task ID was not received',
        }),
      );
      return;
    }

    const taskId = parsed.data.task_id;
    dispatch(
      videoMergeActions.taskCreated({
        taskId,
        name: payload.name,
        videoCount: payload.video_nodes.length,
        createdAt: Date.now(),
      }),
    );
  });
}

function formatSubmitErrorMessage(response: unknown) {
  const messages = z
    .object({
      data: z.array(z.string()),
    })
    .safeParse(response);

  if (messages.success) {
    return messages.data.data.join('\n');
  }

  const record = z.record(z.string(), z.unknown()).safeParse(response);

  if (record.success) {
    return JSON.stringify(record.data);
  }

  return 'Failed to start video merge';
}

function watchTaskCreated() {
  lm.takeEvery(videoMergeActions.taskCreated, async ({ payload }, { dispatch }) => {
    const taskResult = await runTask(payload.taskId, 2000, undefined, ({ status, data }) => {
      if (status === 'STARTED') {
        const parsed = z
          .object({
            stage: z.string(),
          })
          .safeParse(data);

        if (parsed.success) {
          dispatch(
            videoMergeActions.taskChanged({
              taskId: payload.taskId,
              stage: parsed.data.stage,
            }),
          );
        }
      }
    });

    if (taskResult.success) {
      dispatch(
        videoMergeActions.taskSucceeded({
          taskId: payload.taskId,
          taskResult: taskResult.data,
        }),
      );
    } else {
      dispatch(
        videoMergeActions.taskFailed({
          taskId: payload.taskId,
          errorMessage: formatTaskErrorMessage(taskResult.data, taskResult.error),
        }),
      );
    }
  });
}

function formatTaskErrorMessage(data: unknown, fallback: string) {
  const message = z
    .object({ message: z.union([z.string(), z.number(), z.boolean()]) })
    .safeParse(data);

  if (message.success) {
    return String(message.data.message);
  }

  return fallback;
}
